module.exports = __webpack_public_path__ + "static/media/debt-management.e54221e8.svg";